import React from 'react';
import { Checkbox } from 'tea-component';
import BubbleCommon from '@op/components/BubbleCommon';
import SvgIcon from '@home/components/SvgIcon';
import './index.scss';

interface IEventToggleSettingProps {
  showEventBubbles: boolean;
  disabled: boolean;
  onToggle: (value: boolean) => void;
  onOpenSettings: () => void;
}

const showEventTips = {
  en: (
    <>
      Click Event Settings to manage displayed events.
      <br />
      Too many selected events may cause incomplete display on the chart.
      <br />
      If an event is missing, please contact Judymao@tencent.com
    </>
  ),
  zh: (
    // <>
    //   点击进入【事件设置】，可调整需要展示的事件。
    //   <br />
    //   所选事件过多时，可能会导致图表上事件显示不全，请点击进入【事件设置】，减少当前所选事件。
    //   <br />
    //   如有事件未被录入, 请联系 Judymao@tencent.com新增事件。
    // </>
    <>
      Click Event Settings to manage displayed events.
      <br />
      Too many selected events may cause incomplete display on the chart.
      <br />
      If an event is missing, please contact Judymao@tencent.com
    </>
  ),
};

const noEventsForPeriodTips = {
  en: 'There are no events for this period.',
  zh: 'There are no events for this period.',
};

const EventToggleSetting: React.FC<IEventToggleSettingProps> = ({
  showEventBubbles,
  disabled,
  onToggle,
  onOpenSettings,
}) => (
  <div className="dbs-events-setting">
    <BubbleCommon
      showIcon={false}
      tipsMap={disabled ? noEventsForPeriodTips : showEventTips}
    >
      <div className={`dbs-events-setting-inner ${disabled ? 'is-disabled' : ''}`}>
        <Checkbox
          value={disabled ? false : showEventBubbles}
          disabled={disabled}
          onChange={onToggle}
        >
          <span className={disabled ? 'is-disabled' : ''}>Show Events</span>
        </Checkbox>
        <span
          className={`dbs-events-setting-icon ${disabled ? 'is-disabled' : ''}`}
          onClick={() => {
            if (disabled) return;
            onOpenSettings();
          }}
        >
          <SvgIcon type="jichushezhi" />
        </span>
      </div>
    </BubbleCommon>
  </div>
);

export default EventToggleSetting;
